import axios from 'axios';
import queryString from 'query-string';
import interceptorResponse from "./interceptorResponse";
import interceptorRequest from "./interceptorRequest";
import appEnv from "../../../AppEnv";

export const axiosFileNodeClient = axios.create({
    timeout: appEnv.TIME_OUT,
    headers: {
        'Content-type': 'multipart/form-data',
        'Access-Control-Allow-Origin' : '*',
        'Platform': 'app'
    },
    paramsSerializer: params => queryString.stringify(params)
});

axiosFileNodeClient.defaults.baseURL = appEnv.HOST_SERVICE_NODE;
axiosFileNodeClient.interceptors.request.use(interceptorRequest);
axiosFileNodeClient.interceptors.response.use(interceptorResponse, error => {throw error});
